import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect } from "react";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function FinanceDetailsForm(props, ref) {
  const [budgetOptions, setBudgetOptions] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [subLeadSourceList, setSubLeadSourceList] = useState([]);
  const [selectedFunding, setSelectedFunding] = useState(null);
  const [selectedBudget, setSelectedBudget] = useState(null);
  const [selectedLeadSource, setSelectedLeadSource] = useState(null);
  const [selectedSubleadSource, setSelectedSubleadSource] = useState(null);

  // Map labels to local image files
  const imageMap = {
    yes: "SAPImages/intake/yes.png",
    no: "SAPImages/intake/no.png",
    online: "SAPImages/intake/online.png",
    offline: "SAPImages/intake/offline.png",
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}budget`)
      .then((response) => response.json())
      .then((data) => {
        setBudgetOptions(data?.data);
      })
      .catch((error) => {
        console.error("Error fetching budgets:", error);
      });
  }, []);

  // Lead Source
  useEffect(() => {
    fetch(`${API_ENDPOINT}leadsource`)
      .then((response) => response.json())
      .then((data) => {
        const filteredddata = data.filter((i) => i.is_active === true);
        setLeadSourceList(filteredddata);
      })
      .catch((error) => {
        console.error("Error fetching lead source:", error);
      });
  }, []);

  //  Fetch sub lead Source
  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}subleadsource`)
      .then((response) => response.json())
      .then((data) => {
        const filteredData = data.filter(
          (i) => i.lead_source_type_id === selectedLeadSource
        );
        setSubLeadSourceList(filteredData);
      })
      .catch((error) => {
        console.error("Error fetching sub lead source:", error);
      });
  }, [selectedLeadSource]);

  //  Validation & data collection
  useImperativeHandle(ref, () => ({
    validate: () => {
      if (selectedFunding == null) {
        alert("Please select whether you require funding.");
        return false;
      }
      if (!selectedBudget) {
        alert("Please select your budget.");
        return false;
      }
      if (!selectedLeadSource) {
        alert("Please select a lead source.");
        return false;
      }
      if (!selectedSubleadSource) {
        alert("Please select a sub lead source.");
        return false;
      }
      return true;
    },

    getData: () => ({
      self_funding: selectedFunding,
      budget_id: selectedBudget,
      lead_source_id: selectedLeadSource,
      sub_lead_source_id: selectedSubleadSource,
    }),
  }));

  return (
    <Box
      className="scrollbar-hide"
      sx={{
        //  Add Scrollbar
        maxHeight: "400px",
        overflowY: "auto",

        /* Optional: smooth scrollbar look */
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#D9D9D9",
          borderRadius: "8px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#F5F5F5",
        },
      }}
    >
      {/* Question: Financial fund */}
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontStyle: "normal",
          fontSize: "medium",
          lineHeight: "100%",
          letterSpacing: "0px",
          verticalAlign: "middle",
          mb: 3,
          color: "#111111",
        }}
      >
        Do you require financial funding?
      </Typography>

      <Grid container spacing={2}>
        {[
          { label: "Yes", value: true },
          { label: "No", value: false },
        ].map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option.value.toString()}>
            <Button
              fullWidth
              onClick={() => setSelectedFunding(option.value)}
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px #0000001A",
                color: selectedFunding === option.value ? "#572575" : "#000",
                backgroundColor:
                  selectedFunding === option.value ? "#F9EEFF" : "#fff",
                "&:hover": {
                  backgroundColor:
                    selectedFunding === option.value ? "#F9EEFF" : "#f5f5f5",
                },
                border:
                  selectedFunding === option.value ? "2px solid #572575" : "",
                textTransform: "none",
                fontFamily: "inter",
                fontSize: "16px",
                fontWeight: selectedFunding === option.value ? 600 : 400,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                p: 2,
              }}
            >
              <img
                src={
                  imageMap[option.label.toLowerCase()] ||
                  "SAPImages/academic/10th.png"
                }
                alt={option.label}
                style={{ width: "30px", height: "30px", objectFit: "contain" }}
              />
              {option.label}
            </Button>
          </Grid>
        ))}
      </Grid>

      {/* Buget */}
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontStyle: "normal",
          fontSize: "medium",
          lineHeight: "100%",
          letterSpacing: "0px",
          verticalAlign: "middle",
          mb: 3,
          color: "#111111",
          mt: 4,
        }}
      >
        What is your budget ?
      </Typography>

      <Grid container spacing={2}>
        {budgetOptions.map((test) => (
          <Grid item xs={12} sm={6} md={4} key={test.id}>
            <Button
              fullWidth
              onClick={() => {
                setSelectedBudget(test.id);
              }}
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px #0000001A",
                color: selectedBudget === test.id ? "#572575" : "#000",
                backgroundColor:
                  selectedBudget === test.id ? "#F9EEFF" : "#fff",
                "&:hover": {
                  backgroundColor:
                    selectedBudget === test.id ? "#F9EEFF" : "#f5f5f5",
                },
                border: selectedBudget === test.id ? "2px solid #572575" : "",
                textTransform: "none",
                fontFamily: "inter",
                fontSize: "16px",
                fontWeight: selectedBudget === test.id ? 600 : 400,
                py: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              {test.budget_range}
            </Button>
          </Grid>
        ))}
      </Grid>

      <Box mt={4}>
        {/* Lead Source*/}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontStyle: "normal",
            fontSize: "medium",
            lineHeight: "100%",
            letterSpacing: "0px",
            verticalAlign: "middle",
            mb: 3,
            color: "#111111",
            mt: 4,
          }}
        >
          How did you hear about us?
        </Typography>

        <Grid container spacing={2}>
          {leadSourceList.map((type) => (
            <Grid item xs={6} sm={4} md={4} key={type.id}>
              <Button
                fullWidth
                onClick={() => {
                  setSelectedLeadSource(type.id);
                  setSelectedSubleadSource(null);
                }}
                sx={{
                  borderRadius: "8px",
                  boxShadow: "0px 0px 10px 0px #0000001A",
                  color: selectedLeadSource === type.id ? "#572575" : "#000",
                  backgroundColor:
                    selectedLeadSource === type.id ? "#F9EEFF" : "#fff",
                  "&:hover": {
                    backgroundColor:
                      selectedLeadSource === type.id ? "#F9EEFF" : "#f5f5f5",
                  },
                  border:
                    selectedLeadSource === type.id ? "2px solid #572575" : "",
                  textTransform: "none",
                  fontFamily: "inter",
                  fontSize: "16px",
                  fontWeight: selectedLeadSource === type.id ? 600 : 400,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  p: 2,
                }}
              >
                <img
                  src={
                    imageMap[type.name.toLowerCase()] ||
                    "SAPImages/academic/10th.png"
                  }
                  alt={type.name}
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
                {type.name}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* Dropdown for lead source */}
        {selectedLeadSource && (
          <Box mt={3}>
            <FormControl fullWidth>
              <Select
                value={selectedSubleadSource}
                onChange={(e) => setSelectedSubleadSource(e.target.value)}
                displayEmpty
                sx={{
                  height: 48,
                  borderRadius: "12px",
                  backgroundColor: "#FBF6FF",
                  boxShadow: "0px 1px 4px rgba(0,0,0,0.12)",
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                renderValue={(selected) => {
                  if (!selected) {
                    return <span style={{ color: "#999" }}>Select Option</span>;
                  }
                  const item = subLeadSourceList?.find(
                    (s) => s.id === selected
                  );
                  return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {item?.icon && (
                        <Box sx={{ width: 22, height: 22 }}>{item.icon}</Box>
                      )}
                      {item?.source_type}
                    </Box>
                  );
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      mt: 1,
                      borderRadius: "12px",
                      boxShadow: "0px 4px 14px rgba(0,0,0,0.15)",
                    },
                  },
                }}
              >
                <MenuItem value={null}>
                  <em>Select Option</em>
                </MenuItem>

                {subLeadSourceList?.map((source) => (
                  <MenuItem
                    key={source?.id}
                    value={source?.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1.2,
                      borderRadius: "8px",
                      "&.Mui-selected": {
                        backgroundColor: "rgba(255, 0, 255, 0.08)",
                        fontWeight: 600,
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "rgba(255, 0, 255, 0.12)",
                      },
                    }}
                  >
                    {source?.icon && (
                      <Box sx={{ width: 22, height: 22 }}>{source.icon}</Box>
                    )}
                    {source?.source_type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default forwardRef(FinanceDetailsForm);
